import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=6833f6e5&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=ts&"
export * from "./ImageView.vue?vue&type=script&lang=ts&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=6833f6e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833f6e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
